<template>
	<div>
	<router-view class="route"></router-view>
	</div>
</template>


<script>
	export default {
		name: 'App',
		components: {
		},
	}
	
	
</script>

<style>
	.route{
		margin-top:16px;
	}

	#app {
		font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;
		font-size: 12px;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
		margin-top: 0px;
	}
</style>
